import { generalConstants } from "@/utils/constants";

// pagination params object 
export const defaultPaginationParams = {
  totalPages: null, // count of total pages required for the pagination
  currentPage: 1, // value of current page
  offset: null, // offset from the current page
  productsLengthPerPage: generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU, // used for calculating the length of total required pages
  totalFetchedProducts: null, // total number of products fetched
  enableContentTile: false,
  plpRender: false,
  length: generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU, // length of products to be fetched for the current page
};

// handling page number update in URL
const updatePageNumberInURL = (pageNoFromParams) => {
  const url = new URL(window.location.href);

  const searchParams = url.searchParams;
  if(pageNoFromParams === 1) {
    searchParams.delete("page");
  } else {
    searchParams.set("page", pageNoFromParams.toString());
  }
  url.search = searchParams.toString();
  const newURL = url.href;
  if(pageNoFromParams != 1){
    window.history.pushState({ path: newURL }, "", newURL);
  }
};

// calculates the offset by page no.
const getOffsetByPageNo = (pageNo, offset, enableContentTile, plpRender) => {
  switch (pageNo) {
    case 1:
      return enableContentTile ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_B : (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU);
    default:
      return offset + (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU);
  }
}

// handle the length of previous page based on the current page
const handlePreviousPageLength = (pageNo, enableContentTile, plpRender) => {
  switch (pageNo - 1) {
    case 1:
      return enableContentTile ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_B : (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU);
    default:
      return (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU);
  }
}

// handle the offset of previous page based on the current page
const handlePreviousPageOffset = (pageNo, offset, enableContentTile, plpRender) => {
  switch (pageNo - 1) {
    case 1:
      return 0;
    case 2:
      return enableContentTile ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_B : (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU)
    default:
      return offset - (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU)
  }
}

// // calculate the pagination params for a given page
// // Same function is used to set default offset and length at first render
// export const getPaginationParamsByPageNo = (payload, paginationParams) => {
//   const { page: pageNo, shouldChangeURL } = payload;
//   if (shouldChangeURL) {
//     updatePageNumberInURL(pageNo);
//   }
//   return {
//     ...paginationParams,
//     currentPage: pageNo,
//     offset: (pageNo - 1) * generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE,
//   };
// };

// calculate the pagination params for a given page
// Same function is used to set default offset and length at first render
export const getPaginationParamsByPageNo = (payload, paginationParams, defaultValue=false) => {
  const { page: pageNo, shouldChangeURL, plpRender } = payload
  if (shouldChangeURL && !defaultValue) {
    updatePageNumberInURL(pageNo)
  }
  const getOffsetForGivenPage = (page,plpRender) => {
    let initialOffset = 0;
    let firstPageOffset = paginationParams.enableContentTile ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_B : (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU);
    if (paginationParams.enableContentTile) {
      switch (page) {
        case 1:
          return initialOffset
        case 2:
          return firstPageOffset
        default:
          return (page - 2) * (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU) + firstPageOffset
      }
    }
    else {
      return (page - 1) * (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU)
    }
  }

  const getLengthForGivenPage = (page,plpRender) => {
    if (paginationParams.enableContentTile) {
      switch (page) {
        case 1:
          return generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_B
        default:
          return (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU)
      }
    }
    else {
      return (plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU)
    }
  }

  return {
    ...paginationParams,
    currentPage: pageNo,
    offset: getOffsetForGivenPage(pageNo,plpRender),
    length: getLengthForGivenPage(pageNo,plpRender),
  }
}

const updateInitialpaginationParams = (payload, paginationParams) => {
  const { pageData, shouldChangeURL } = payload;
  if (shouldChangeURL) {
    updatePageNumberInURL(1);
  }
  return { ...paginationParams, ...pageData }
};

// pagination helper reducer function
export const paginationHelper = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "UPDATE_INITIAL_PAGINATION_PARAMS":
      return updateInitialpaginationParams(payload, state);
    case "RESET_PAGINATION_PARAMS":
      return { payload };
    // utility actions to handle desktop pagination
    case "FETCH_NEXT_PAGE_DESKTOP":
      updatePageNumberInURL(state.currentPage + 1)
      return {
        ...state,
        currentPage: state.currentPage + 1,
        offset:
          payload.enableContentTile ? getOffsetByPageNo(state.currentPage, state.offset, state.enableContentTile,state.plpRender) : state.offset + (state.plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU),
        length: (payload.plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU),
      }  
    case "FETCH_PREVIOUS_PAGE_DESKTOP":
      updatePageNumberInURL(state.currentPage - 1);
      return {
        ...state,
        currentPage: state.currentPage - 1,
        offset: state.enableContentTile ? handlePreviousPageOffset(state.currentPage, state.offset,state.enableContentTile,state.plpRender) : state.offset - (state.plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU),
        length: state.enableContentTile ? handlePreviousPageLength(state.currentPage, state.enableContentTile,state.plpRender) : (state.plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU)
      };
    case "GO_TO_FIRST_PAGE":
      updatePageNumberInURL(1);
      return {
        ...state,
        currentPage: 1,
        offset: 0,
        length: state.enableContentTile ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_B : (state.plpRender ? generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE : generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE_FOR_YOU),
      };
    case "FETCH_DATA_FOR_SELECTED_PAGE":
      return getPaginationParamsByPageNo(payload, state);
    default:
      return state;
  }
};
